/**
* Service to help create chart data for vue-chartjs plugin
**/
import moment from 'moment';
import _ from 'lodash';

const datasetBase = {
  label: null,
  lineTension: 0.15,
  backgroundColor: '',
  borderColor: '',
  borderWidth: '2',
  pointBackgroundColor: '#fff',
  pointRadius: 4,
  data: []
};

/**
* @param a dataset object
* return dataset merged with default properties
**/
const createDataset = function(dataset) {
  return { ...datasetBase, ...dataset };
};

/**
* @param dateArray An array of java dates in ascending order
* return a list of unique dates, formatted
**/
const getDatesAsLabels = function(dateArray) {
  let dates = _.uniq(dateArray);
  let result = [];
  let curr, prev;
  const lastIndex = dates.length - 1;
  dates.forEach(function(date, index) {
    curr = moment(new Date(date));
    // return full date if it is first date or different year
    if (!prev || prev.year() !== curr.year() || index === lastIndex) {
      result.push(moment(date).format('M/D/YY'));
    } else {
      result.push(moment(date).format('M/D'));
    }
    prev = curr.clone();
  });
  return result;
};

export default {
  createDataset,
  getDatesAsLabels
};
